import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from '@gestor-web/app/shared/modules';
import { AgGridDropdownCellEditor } from './ag-grid-dropdown-cell-editor.component';

@NgModule({
  declarations: [AgGridDropdownCellEditor],
  imports: [CommonModule, FormsModule, PrimengModule],
  exports: [AgGridDropdownCellEditor],
})
export class AgGridDropdownCellEditorModule {}
